export default "__VITE_ASSET__f9943989__"